// CATEGORIA
import Cat1 from "./Categoria/1.png";
import Cat2 from "./Categoria/2.png";
import Cat3 from "./Categoria/3.png";
import Cat4 from "./Categoria/4.png";
import Cat5 from "./Categoria/5.png";
import Cat6 from "./Categoria/6.png";
import Cat7 from "./Categoria/7.png";
import Cat8 from "./Categoria/8.png";
import Cat9 from "./Categoria/9.png";
import Cat10 from "./Categoria/10.png";
import Cat11 from "./Categoria/11.png";
import Cat12 from "./Categoria/12.png";
import Cat13 from "./Categoria/13.png";
import Cat14 from "./Categoria/14.png";
import Cat15 from "./Categoria/15.png";
import Cat16 from "./Categoria/16.png";
import Cat17 from "./Categoria/17.png";
import Cat18 from "./Categoria/18.png";
import Cat19 from "./Categoria/19.png";
import Cat20 from "./Categoria/20.png";
import Cat21 from "./Categoria/21.png";
import Cat22 from "./Categoria/22.png";
import Cat23 from "./Categoria/23.png";
import Cat24 from "./Categoria/24.png";
import Cat25 from "./Categoria/25.png";
import Cat26 from "./Categoria/26.png";
import Cat27 from "./Categoria/27.png";
import Cat28 from "./Categoria/28.png";
import Cat29 from "./Categoria/29.png";
import Cat30 from "./Categoria/30.png";
import Cat31 from "./Categoria/31.png";
import Cat32 from "./Categoria/32.png";
import Cat33 from "./Categoria/33.png";
import Cat34 from "./Categoria/34.png";
import Cat35 from "./Categoria/35.png";
// continue até 35...

// SALDOS
import Saldo1 from "./saldos/1.png";
import Saldo2 from "./saldos/2.png";
import Saldo3 from "./saldos/3.png";

// PESSOA
import Pessoa1 from "./pessoa/1.png";
import Pessoa2 from "./pessoa/2.png";
import Pessoa3 from "./pessoa/3.png";
import Pessoa4 from "./pessoa/4.png";
import Pessoa5 from "./pessoa/5.png";
import Pessoa6 from "./pessoa/6.png";
import Pessoa7 from "./pessoa/7.png";
import Pessoa8 from "./pessoa/8.png";
import Pessoa9 from "./pessoa/9.png";
import Pessoa10 from "./pessoa/10.png";
import Pessoa11 from "./pessoa/11.png";
import Pessoa12 from "./pessoa/12.png";
import Pessoa13 from "./pessoa/13.png";
import Pessoa14 from "./pessoa/14.png";
import Pessoa15 from "./pessoa/15.png";
import Pessoa16 from "./pessoa/16.png";
import Pessoa17 from "./pessoa/17.png";
import Pessoa18 from "./pessoa/18.png";
import Pessoa19 from "./pessoa/19.png";
import Pessoa20 from "./pessoa/20.png";
import Pessoa21 from "./pessoa/21.png";
import Pessoa22 from "./pessoa/22.png";
import Pessoa23 from "./pessoa/23.png";

export const imagensCategoria = {
  0: Cat1,
  1: Cat2,
  2: Cat3,
  3: Cat4,
  4: Cat5,
  5: Cat6,
  6: Cat7,
  7: Cat8,
  8: Cat9,
  9: Cat10,
  10: Cat11,
  11: Cat12,
  12: Cat13,
  13: Cat14,
  14: Cat15,
  15: Cat16,
  16: Cat17,
  17: Cat18,
  18: Cat19,
  19: Cat20,
  20: Cat21,
  21: Cat22,
  22: Cat23,
  23: Cat24,
  24: Cat25,
  25: Cat26,
  26: Cat27,
  27: Cat28,
  28: Cat29,
  29: Cat30,
  30: Cat31,
  31: Cat32,
  32: Cat33,
  33: Cat34,
  34: Cat35
};

export const imagensSaldo = {
  0: Saldo1,
  1: Saldo2,
  2: Saldo3
};

export const imagensPessoa = {
  0: Pessoa1,
  1: Pessoa2,
  2: Pessoa3,
  3: Pessoa4,
  4: Pessoa5,
  5: Pessoa6,
  6: Pessoa7,
  7: Pessoa8,
  8: Pessoa9,
  9: Pessoa10,
  10: Pessoa11,
  11: Pessoa12,
  12: Pessoa13,
  13: Pessoa14,
  14: Pessoa15,
  15: Pessoa16,
  16: Pessoa17,
  17: Pessoa18,
  18: Pessoa19,
  19: Pessoa20,
  20: Pessoa21,
  21: Pessoa22,
  22: Pessoa23  
};